import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { CallsPage } from "./CallsPage";
import "./styles.css";

// Minimal pathname router — no react-router dependency.
const path = (typeof window !== "undefined" ? window.location.pathname : "/").toLowerCase();
const root = path.startsWith("/calls") ? <CallsPage /> : <App />;

createRoot(document.getElementById("root")!).render(
  <StrictMode>{root}</StrictMode>,
);
